// extracted by mini-css-extract-plugin
export var adCard = "_oj-8";
export var adCardBorder = "_oj-5";
export var arbiterButtonIcon = "_oj-p";
export var buttonIcon = "_oj-o";
export var container = "_oj-e";
export var copyButton = "_oj-m";
export var darkGrey = "_oj-u";
export var deliveryDate = "_oj-2";
export var divider = "_oj-n";
export var editModeWrapper = "_oj-7";
export var empty = "_oj-a";
export var errorIcon = "_oj-d";
export var filledCircle = "_oj-4";
export var fulfillmentFooter = "_oj-j";
export var grey = "_oj-s";
export var header = "_oj-i";
export var headerWrapper = "_oj-h";
export var highlighted = "_oj-6";
export var historyEntry = "_oj-3";
export var mobileColumn = "_oj-v";
export var mobileColumnReverse = "_oj-w";
export var orderDetailsContainer = "_oj-g";
export var orderMetadata = "_oj-l";
export var orderMetadataWrapper = "_oj-k";
export var packagesContainer = "_oj-b";
export var product = "_oj-y";
export var productImage = "_oj-z";
export var productInfo = "_oj-x";
export var productTitle = "_oj-10";
export var strikethrough = "_oj-t";
export var tinyText = "_oj-r";
export var title = "_oj-9";
export var trackerCard = "_oj-1";
export var trackerCardWrapper = "_oj-0";
export var trackingContainer = "_oj-f";
export var trackingTitle = "_oj-c";
export var xTinyText = "_oj-q";